<ng-container *ngIf="entry;then entryCard else noItem"></ng-container>

<ng-template #entryCard>
    <div class="entry-icon">
        <app-icon class="icon"
                  [simple]="true"
                  type="info"
                  library="custom"
                  [variant]="entry?.icon">
        </app-icon>
        <p class="text">{{ entry?.iconLabel }}</p>
    </div>
    <div class="entry-info">
        <div class="title">{{ entry?.title }}</div>
        <div class="subtitle" [class]="status">{{ entry?.subTitle | translate }}</div>
        <div class="extra">{{ entry?.extra }}</div>
    </div>
</ng-template>

<ng-template #noItem>
    No Items!
</ng-template>
